import React from 'react'

import { Tooltip as ReactTooltip } from "react-tooltip";
import { ls } from '../../../locale'

export function FareTooltip({fareTypeName}: {fareTypeName: string}) {

  if(!fareTypeName) return null;
  fareTypeName = fareTypeName.replace(/ /g, "");

  const rFareType = ls.t('FareType')[fareTypeName]
  if(!rFareType) return null;

  let mealDesc = rFareType.Meal?.Desc;
  if(typeof mealDesc === 'string') mealDesc = mealDesc.split(/[\r\n]/);

  let priorityDesc = rFareType.PriorityCheckin?.Desc;
  if(typeof priorityDesc === 'string') priorityDesc = priorityDesc.split(/[\r\n]/);

  let changeDesc = rFareType.ChangeFlight.Desc;
  if(typeof changeDesc === 'string') changeDesc = changeDesc.split(/[\r\n]/);

  let cancelDesc = rFareType.CancelFlight.Desc;
  if(typeof cancelDesc === 'string') cancelDesc = cancelDesc.split(/[\r\n]/);
    
  return (
    <>
      <ReactTooltip id={"meal" + fareTypeName} className={"fare-tooltip " + ls.t('rootClass')}>
        { Array.isArray(mealDesc) && mealDesc.map((detail: string, index: number) => <p key={index}>{detail}</p>)}
      </ReactTooltip>
      <ReactTooltip id={"priority" + fareTypeName} className={"fare-tooltip " + ls.t('rootClass')}>
        {Array.isArray(priorityDesc) && priorityDesc.map((detail: string, index: number) => <p key={index}>{detail}</p>)}
      </ReactTooltip>
      <ReactTooltip id={"changePolicy" + fareTypeName} className={"fare-tooltip " + ls.t('rootClass')}>
        { Array.isArray(changeDesc) && changeDesc.map((detail: string, index: number) => <p key={index}>{detail}</p>)}
      </ReactTooltip>
      <ReactTooltip id={"cancelPolicy" + fareTypeName} className={"fare-tooltip " + ls.t('rootClass')}>
        {Array.isArray(cancelDesc) && cancelDesc.map((detail: string, index: number) => <p key={index}>{detail}</p>)}
      </ReactTooltip>
    </>
  )
}